import {
  CircularProgress,
  InputAdornment,
  OutlinedInput,
  Select,
  type SelectProps
} from '@mui/material'

export interface LoadingSelectProps extends Omit<SelectProps, 'input'> {
  isLoading: boolean
  label: string
}

export default function LoadingSelect({
  isLoading,
  children,
  label,
  ...rest
}: Readonly<LoadingSelectProps>) {
  return (
    <Select
      input={
        <OutlinedInput
          label={label}
          endAdornment={
            isLoading ? (
              <InputAdornment position="end">
                <CircularProgress size={20} sx={{ marginRight: '-5px' }} />
              </InputAdornment>
            ) : null
          }
        />
      }
      {...rest}
    >
      {children}
    </Select>
  )
}
